"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertColumns = insertColumns;
exports.removeColumns = removeColumns;
exports.removeColumnsFromRows = removeColumnsFromRows;
exports.addColumnsToRows = addColumnsToRows;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = require("lodash");

function insertColumns(columns, index, addColumns) {
  var newColumns = columns.slice();
  newColumns.splice.apply(newColumns, [index, 0].concat((0, _toConsumableArray2.default)(addColumns)));
  return newColumns;
}

function removeColumns(columns, index, amount) {
  var newColumns = columns.slice();
  newColumns.splice(index, amount);
  return newColumns;
}

function removeColumnsFromRows(columns, rows) {
  return rows.map(function (row) {
    return (0, _lodash.pick)(row, columns);
  });
}

function addColumnsToRows(columns, rows) {
  var newRowColumns = columns.reduce(function (rowColumns, column) {
    return (0, _objectSpread3.default)({}, rowColumns, (0, _defineProperty2.default)({}, column, ''));
  }, {});
  return rows.map(function (row) {
    return (0, _objectSpread3.default)({}, newRowColumns, row);
  });
}